import { Config } from '@ratehub/base-ui';

/**
 * Given the purchase price, returns the minimum down payment in dollars.
 *
 * @param {number} purchasePrice
 * @returns {number} minimum down payment
 */
function getMinimumDownPaymentDollars(purchasePrice) {
    // Remove Experiment MTG-3796
    const maximumPurchasePrice = Config.ENABLE_GOC_MORTGAGE_REFORM
        ? 1_500_000
        : 1_000_000;

    if (typeof purchasePrice !== 'number' || Number.isNaN(purchasePrice)) {
        return 0;
    }

    if (purchasePrice <= 500_000) {
        return Math.round((0.05 * purchasePrice) * 100) / 100;
    }

    if (purchasePrice >= maximumPurchasePrice) {
        return Math.round((0.2 * purchasePrice) * 100) / 100;
    }
    // 5% of first $500,000, 10% of the remainder
    return Math.round((0.05 * 500_000 + 0.1 * (purchasePrice - 500_000)) * 100) / 100;
}

/**
 *
 * @param {number} purchasePrice
 * @returns {number} minimum down payment percent
 */
function getMinimumDownPaymentPercent(purchasePrice) {
    if (typeof purchasePrice !== 'number' || Number.isNaN(purchasePrice)) {
        return 0;
    }

    const downPayment = getMinimumDownPaymentDollars(purchasePrice);

    return (downPayment / purchasePrice) * 100;
}

export {
    getMinimumDownPaymentDollars,
    getMinimumDownPaymentPercent,
};
